import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { formatDate } from '@ifca-root/react-component/src/helpers/StringNumberFunction/formatDate'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import {
  useGetCategoryChangeStatusListingQuery,
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { ChangeAssetCategoryDetailContent } from '../ChangeAssetCategoryDetail/ChangeAssetCategoryDetailContent'

export const ChangeAssetCategoryDetail = (props: any) => {
  let history = useHistory()
  const { mode } = props
  const { CompanyID, ChangeAssetCategoryID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    clearErrors,
  } = useForm<any>()
  const [audioInput, setAudioInput] = useState('')
  const [record, setRecord] = useState(false)
  const [text, setText] = useState(mode === 'add' ? '' : editData?.remark)
  const [singleRemark, setSingleRemark] = useState(null)
  const handleSingleRemark = remark => {
    setSingleRemark(remark)
  }

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const {
    loading: categoryChangeLoading,
    data: { getCategoryChangeStatusListing } = {
      getCategoryChangeStatusListing: { Data: [], TotalLength: 0 },
    },
  } = useGetCategoryChangeStatusListingQuery({
    variables: {
      CompanyID,
      StatusArr: ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED'],
      skip: 0,
      take: 1000,
    },
    fetchPolicy: 'network-only',
    skip: !CompanyID,
  })

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  /* -------------------------------------------- */
  /*                    VARIABLE                  */
  /* -------------------------------------------- */
  const categoryChangeData =
    editData ||
    getCategoryChangeStatusListing?.Data?.find(
      (item: any) => item.category_change_id === ChangeAssetCategoryID
    )

  const rejectFooterOption = {
    name: 'Reject',
    onClick: () => {
      setOpenRejectDialog(false)
    },
    color: 'secondary',
    props: { type: 'submit' },
  }

  const approveFooterOption = {
    name: 'Approve',
    onClick: () => {
      setOpenRejectDialog(false)
    },
    color: 'primary',
    props: { type: 'submit' },
  }
  const footerOptions: any[] = [rejectFooterOption, approveFooterOption]

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'ACTIVE':
        return 'Draft'
      case 'SUBMIT':
        return 'Submitted'
      case 'COMPLETED':
        return 'Approved'
      case 'REJECTED':
        return 'Rejected'
      default:
        return 'Detail'
    }
  }

  const isLoading = getUsersByAccountAndSoftwareLoading || categoryChangeLoading

  return (
    <>
      {isLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/change-asset-category`
          )
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Change Asset Category', current: true },
        ]}
        rightRouteSegments={[
          {
            name: getStatusLabel(categoryChangeData?.ApprovalStatus),
            current: true,
          },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {categoryChangeData?.Asset?.name || 'N/A'}
            </span>
          </span>
        }
        rightText={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {categoryChangeData?.DocNo || 'N/A'}
            </span>
          </span>
        }
        infoLine={
          <div
            className="text-overflow"
            style={{ fontSize: '11px', width: '270px' }}
          >
            <span>
              {`From: `}
              <span style={{ textDecoration: 'line-through' }}>
                {categoryChangeData?.OldCategory?.name || 'N/A'}
              </span>
            </span>
            <br />
            <span>
              {`To: `}
              <span>{categoryChangeData?.NewCategory?.name || 'N/A'}</span>
            </span>
          </div>
        }
        rightInfoLine={
          <span>
            {categoryChangeData?.change_date
              ? formatDate(categoryChangeData.change_date)
              : 'N/A'}
          </span>
        }
      />

      <ContentWrapper multiDynamicInfo float={false}>
        <CardContents>
          <ChangeAssetCategoryDetailContent
            listEl={categoryChangeData}
            listStatus={categoryChangeData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
      </ContentWrapper>

      {mode === 'workdesk' ? <Footer options={[...footerOptions]} /> : null}

      <RejectDialog
        data={categoryChangeData}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        audioInput={audioInput}
        record={record}
        setRecord={setRecord}
        setValue={setValue}
        errors={errors}
        register={register}
        control={control}
        clearErrors={clearErrors}
        setText={setText}
        handleSingleRemark={handleSingleRemark}
      />
    </>
  )
}
